import Login from "./Login";

const AuthPage = () => {
    return (
            <Login />
    );
};

export default AuthPage;
